var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_16492",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_16492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 5.80005C11.3509 5.80005 10.7915 5.5678 10.3248 5.1033C9.85815 4.63897 9.62482 4.08063 9.62482 3.4283C9.62482 2.77613 9.85707 2.21672 10.3216 1.75005C10.7859 1.28338 11.3442 1.05005 11.9966 1.05005C12.6487 1.05005 13.2082 1.2823 13.6748 1.7468C14.1415 2.21113 14.3748 2.76947 14.3748 3.4218C14.3748 4.07397 14.1426 4.63338 13.6781 5.10005C13.2137 5.56672 12.6554 5.80005 12.0031 5.80005ZM8.54982 20.9V9.44555C7.79982 9.38188 7.04982 9.30005 6.29982 9.20005C5.54982 9.10005 4.79982 8.96672 4.04982 8.80005C3.66649 8.71672 3.37065 8.50838 3.16232 8.17505C2.95399 7.84172 2.89982 7.48338 2.99982 7.10005C3.09982 6.71672 3.32482 6.43755 3.67482 6.26255C4.02482 6.08755 4.39149 6.04172 4.77482 6.12505C5.95815 6.37505 7.16649 6.55005 8.39982 6.65005C9.63315 6.75005 10.8332 6.80005 11.9998 6.80005C13.1665 6.80005 14.3707 6.75005 15.6123 6.65005C16.854 6.55005 18.0748 6.37505 19.2748 6.12505C19.6582 6.04172 20.0192 6.08897 20.3578 6.2668C20.6967 6.44447 20.919 6.72222 21.0248 7.10005C21.1248 7.48338 21.0665 7.83755 20.8498 8.16255C20.6332 8.48755 20.3332 8.69172 19.9498 8.77505C19.1998 8.94172 18.4498 9.07922 17.6998 9.18755C16.9498 9.29588 16.1998 9.38188 15.4498 9.44555V20.9C15.4498 21.2895 15.3181 21.6161 15.0546 21.8798C14.7911 22.1433 14.4645 22.275 14.0748 22.275C13.6853 22.275 13.3587 22.1433 13.0951 21.8798C12.8316 21.6161 12.6998 21.2895 12.6998 20.9V16H11.2998V20.9C11.2998 21.2895 11.1681 21.6161 10.9046 21.8798C10.6411 22.1433 10.3145 22.275 9.92482 22.275C9.53532 22.275 9.20874 22.1433 8.94507 21.8798C8.68157 21.6161 8.54982 21.2895 8.54982 20.9Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysical);
export default __webpack_public_path__ + "static/media/physical.a256310192d97b2e9c570571a2099900.svg";
export { ForwardRef as ReactComponent };